<lib-active-filters></lib-active-filters>
<div class="breadcrumbs">
    <button class="back-button" (click)="navigateToDashboard()">
        <mat-icon>arrow_back_ios</mat-icon>
        <span class="breadcrumb-text">{{ breadCrumbTextHome }}</span>
    </button>
    <span class="breadcrumb-text">{{ breadCrumbTextDefectHistory }}</span>
</div>
<div class="panel-flex">
    <app-defect-list-view
        [@toggle-main-panel]="isDetailOpen ? 'open' : 'closed'"
        [isDetailOpen]="isDetailOpen"
        [activeSerial]="serial"
        [startDate]="startDate"
        [endDate]="endDate"
        (selectedSerial)="selectSerial($event)">
    </app-defect-list-view>
    @if(serial) {
        <app-defect-detail-view
            [@toggle-detail-panel]="isDetailOpen ? 'open' : 'closed'"
            (closeDetailView)="closeDetail()"
            [defectViewItem]="serial"
            [serialNumber]="serial.SerialNumber">
        </app-defect-detail-view>
    }
</div>
